import HomeScreen from "@/UI/screens/HomeScreen";

export default function HomeRoute() {
    return <HomeScreen />;
}
